// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LocaleConstants$PorterinUtils from "./LocaleConstants.mjs";

var countries = [
  {
    TAG: /* BD */0,
    _0: LocaleConstants$PorterinUtils.bdLocales
  },
  {
    TAG: /* AE */1,
    _0: LocaleConstants$PorterinUtils.aeLocales
  },
  {
    TAG: /* TR */2,
    _0: LocaleConstants$PorterinUtils.trLocales
  },
  {
    TAG: /* IND */3,
    _0: LocaleConstants$PorterinUtils.indLocales
  }
];

function stackCountries(stack) {
  if (stack === "uae") {
    return [
            {
              TAG: /* BD */0,
              _0: LocaleConstants$PorterinUtils.bdLocales
            },
            {
              TAG: /* AE */1,
              _0: LocaleConstants$PorterinUtils.aeLocales
            },
            {
              TAG: /* TR */2,
              _0: LocaleConstants$PorterinUtils.trLocales
            }
          ];
  } else {
    return [{
              TAG: /* IND */3,
              _0: LocaleConstants$PorterinUtils.indLocales
            }];
  }
}

var bd = "bd";

var ae = "ae";

var uae = "uae";

var tr = "tr";

var ind = "in";

var gaBd = "BD";

var gaUae = "UAE";

var gaTr = "TR";

var gaInd = "IND";

export {
  bd ,
  ae ,
  uae ,
  tr ,
  ind ,
  gaBd ,
  gaUae ,
  gaTr ,
  gaInd ,
  countries ,
  stackCountries ,
}
/* No side effect */
